import { createGetLastHistoryStackActionSelector } from '../../history-stack';
import { getAdminPanelsHistory } from './get-admin-panels-history';

export const getAdminPanelsHistoryLastAction = createGetLastHistoryStackActionSelector(
  getAdminPanelsHistory,
);
